module.exports = __webpack_public_path__ + "static/media/0027_IMG_LA_CAVE.8e71ad23.webp";